

// import React from 'react';
// import css from '../Modulecss/Home.module.css';
// import { Link } from 'react-router-dom';

// // Utility function to get the first name or a truncated version
// const getPlayerDisplayName = (player) => {
//   const name = player?.Name || 'Unknown';
//   const parts = name.split(' ');
//   // Use the first part if available, otherwise truncate the whole name
//   return parts[0] || name.substring(0, 10);
// };

// export default function RunningCard({ runnig, user, winnAmount, game_type }) {
//   // Determine if the current user is a participant to show the VIEW button
//   const isParticipant =
//     user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id;

//   // Player Data
//   const player1 = runnig.Created_by;
//   const player2 = runnig.Accepetd_By;
//   const gameAmount = runnig.Game_Ammount;
//   const prizeAmount = gameAmount + winnAmount(gameAmount);

//   return (
//     <>
//       {/* 1. Add CSS Keyframes for the Slide Animation */}
//       <style>
//         {`
//           @keyframes slideInLeft {
//             from {
//               opacity: 0;
//               transform: translateX(-100%);
//             }
//             to {
//               opacity: 1;
//               transform: translateX(0);
//             }
//           }
//           .slide-in-left {
//             animation: slideInLeft 0.5s ease-out forwards;
//           }

//           /* Compact Card Styles */
//           .running-card-compact {
//             background: linear-gradient(145deg, #ffffff, #f9f9f9); 
//             border: 2px solid #a8c0ff;
//             border-radius: 10px; 
//             box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
//             padding: 8px 10px; /* Reduced vertical padding */
//             font-family: Arial, sans-serif;
//           }

//           .player-name-compact {
//             font-size: 11px;
//             font-weight: 700;
//             color: #333;
//             text-overflow: ellipsis;
//             white-space: nowrap;
//             overflow: hidden;
//             max-width: 60px; 
//             margin-top: 4px;
//           }
          
//           .amount-text {
//             font-weight: 800;
//             font-size: 14px;
//           }
          
//           /* Custom VS style to mimic the image's logo */
//           .vs-logo {
//             font-size: 18px; /* Slightly larger VS */
//             font-weight: 900;
//             color: #FF4500; /* Use a red/orange color for emphasis */
//             margin: 0 5px;
//             text-shadow: 0 0 2px rgba(0,0,0,0.1);
//           }
//         `}
//       </style>

//       {/* 2. Apply the animation class and new compact card style */}
//       <div className="mx-2 mb-2 slide-in-left running-card-compact">
//         {/* Top Bar: Playing For | Prize (Aligned Left/Right) */}
//         <div className="d-flex align-items-center justify-content-between mb-3" style={{ paddingBottom: '5px', borderBottom: '1px solid #f0f0f0' }}>
          
//           {/* Playing For / Entry Fee (Left Aligned) */}
//           <div className="d-flex align-items-center">
//             <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '4px' }}>
//               Playing For
//             </span>
//              <img
//                             src="/images/LandingPage_img/global-rupeeIcon.png"
//                             alt="prize"
//                             width="15px"
//                             className="mr-1"
//                         />
//             <span className="amount-text" style={{ color: '#000' }}>
//               {gameAmount}
//             </span>
//           </div>

//           {/* Prize (Right Aligned) */}
//           <div className="d-flex align-items-center">
//             <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '4px' }}>
//               Prize
//             </span>
//             <img
//                             src="/images/LandingPage_img/global-rupeeIcon.png"
//                             alt="prize"
//                             width="15px"
//                             className="mr-1"
//                         />
//             <span className="amount-text" style={{ color: '#000' }}>
//               {prizeAmount}
//             </span>
//           </div>
//         </div>
        
//         {/* Main Content: Player 1 (Left) VS (Center) Player 2 (Right) */}
//         <div className="d-flex align-items-center justify-content-between">
          
//           {/* Player 1 (Creator) - Left Side */}
//           <div className="d-flex flex-column align-items-center text-center" style={{ width: '30%' }}>
//             <img
//               src={process.env.PUBLIC_URL + '/images/avatars/Avatar2.png'}
//               alt="P1"
//               width="40px" /* Slightly increased avatar size for visibility */
//               height="40px"
//               style={{
//                 borderRadius: '50%',
//                 border: '2px solid #FF4500', 
//               }}
//             />
//             <div className="player-name-compact mx-auto">
//               {getPlayerDisplayName(player1)}
//             </div>
//           </div>

//           {/* VS Divider - Center */}
//           <div className="text-center" style={{ width: '20%' }}>
//             <span className="vs-logo">
//               <img src='/images/Homepage/versus.png' className='img-fluid vs_img' />
//             </span>
//           </div>

//           {/* Player 2 (Accepter) - Right Side */}
//           <div className="d-flex flex-column align-items-center text-center" style={{ width: '30%' }}>
//             <img
//               src={process.env.PUBLIC_URL + '/images/avatars/Avatar3.png'}
//               alt="P2"
//               width="40px"
//               height="40px"
//               style={{
//                 borderRadius: '50%',
//                 border: '2px solid #0000FF',
//               }}
//             />
//             <div className="player-name-compact mx-auto">
//               {getPlayerDisplayName(player2)}
//             </div>
//           </div>

//           {/* VIEW Button - Right Aligned (Outside of player section) */}
//           {isParticipant && (
//             <Link
//               style={{ textDecoration: 'none', width: '20%' }}
//               to={{
//                 pathname: `/viewgame1/${runnig._id}`,
//                 state: { prevPath: window.location.pathname },
//               }}
//             >
//               <button
//                 className="btn btn-sm"
//                 style={{
//                   backgroundColor: '#000', /* Changed button color to black for contrast */
//                   color: '#fff',
//                   fontSize: '9px',
//                   fontWeight: 'bold',
//                   borderRadius: '4px',
//                   padding: '3px 8px',
//                   boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
//                   minWidth: '50px' // Ensure button has minimal size
//                 }}
//               >
//                 VIEW
//               </button>
//             </Link>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }

import React from 'react';
import { Link } from 'react-router-dom';

// Utility function to get the first name or a truncated version
const getPlayerDisplayName = (player) => {
  const name = player?.Name || 'Unknown';
  const parts = name.split(' ');
  return parts[0] || name.substring(0, 10);
};

export default function RunningCard({ runnig, user, winnAmount }) {
  // Determine if the current user is a participant to show the VIEW button
  const isParticipant =
    user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id;

  // Player Data
  const player1 = runnig.Created_by;
  const player2 = runnig.Accepetd_By;
  const gameAmount = runnig.Game_Ammount;
  const prizeAmount = gameAmount + winnAmount(gameAmount);

  return (
    <div
      className="mx-2 mb-2"
      style={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        border: '1px solid #d1d1d1',
        overflow: 'hidden',
        fontFamily: 'sans-serif',
      }}
    >
      {/* Header Section - Purple Title */}
      <div 
        className="px-3 py-1 d-flex justify-content-between align-items-center" 
        style={{ borderBottom: '1px solid #e0e0e0' }}
      >
        <span style={{ color: '#ec9728', fontWeight: '600', fontSize: '14px' }}>
          Live Game
        </span>
        {isParticipant && (
            <Link
                to={{
                    pathname: `/viewgame1/${runnig._id}`,
                    state: { prevPath: window.location.pathname },
                }}
                style={{ textDecoration: 'none' }}
            >
               <span 
  style={{ 
    fontSize: '10px', 
    color: '#fff', 
    fontWeight: '700', 
    borderRadius: '15px', 
    backgroundColor: '#000', 
    padding: '3px 12px', 
    display: 'inline-block',
    letterSpacing: '0.5px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    border: '1px solid #333',
    cursor: 'pointer'
  }}
>
  VIEW
</span>
            </Link>
        )}
      </div>

      {/* Body Section - Light Grey Background */}
      <div 
        className="px-3 py-2" 
        style={{ backgroundColor: '#f9f9f9' }}
      >
        {/* Top Row: Amounts (Minimal Height) */}
        <div className="d-flex justify-content-between align-items-center mb-1">
          <div className="d-flex align-items-center">
            <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '5px' }}>
              Playing For
            </span>
            <img 
              src="/images/LandingPage_img/global-rupeeIcon.png" 
              alt="coin" 
              width="16px" 
            />
            <span style={{ fontSize: '15px', fontWeight: 'bold', marginLeft: '3px', color: '#000' }}>
              {gameAmount}
            </span>
          </div>
          <div className="d-flex align-items-center">
            <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '5px' }}>
              Prize
            </span>
            <img 
              src="/images/LandingPage_img/global-rupeeIcon.png" 
              alt="prize" 
              width="16px" 
            />
            <span style={{ fontSize: '15px', fontWeight: 'bold', marginLeft: '3px', color: '#000' }}>
              {prizeAmount}
            </span>
          </div>
        </div>

        {/* Main Content: Player 1 VS Player 2 (Side-by-Side for minimal thickness) */}
        <div className="d-flex align-items-center justify-content-between mt-1">
          
          {/* Player 1 */}
          <div className="d-flex align-items-center" style={{ width: '42%' }}>
            <img
              src={process.env.PUBLIC_URL + '/images/avatars/Avatar2.png'}
              alt="P1"
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                border: '1.5px solid #FF4500',
              }}
            />
            <div style={{ 
                fontSize: '12px', 
                fontWeight: '700', 
                marginLeft: '6px', 
                color: '#333', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'nowrap' 
            }}>
              {getPlayerDisplayName(player1)}
            </div>
          </div>

          {/* VS Divider */}
          <div className="text-center" style={{ width: '16%' }}>
            <img 
              src='/images/Homepage/versus.png' 
              style={{ width: '20px' }} 
              alt="vs"
            />
          </div>

          {/* Player 2 */}
          <div className="d-flex align-items-center justify-content-end" style={{ width: '42%' }}>
            <div style={{ 
                fontSize: '12px', 
                fontWeight: '700', 
                marginRight: '6px', 
                color: '#333', 
                textAlign: 'right', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'nowrap' 
            }}>
              {getPlayerDisplayName(player2)}
            </div>
            <img
              src={process.env.PUBLIC_URL + '/images/avatars/Avatar3.png'}
              alt="P2"
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                border: '1.5px solid #0000FF',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}